(function () {
	'use strict';
	angular
		.module('rms.common')
		.directive('rmsListFilterSidebarMinimize', rmsListFilterSidebarMinimize);
	function rmsListFilterSidebarMinimize($timeout) {
		return {
			restrict: 'E',
			templateUrl: 'common/app/components/list-filter/sidebar-minimize',
			link: function(scope, elem) {
				scope.listFilterService = scope.$parent.listFilterService;
				const vm = scope.$parent.vm;
				vm.expandSidebar = expandSidebar;

				function expandSidebar() {
					vm.pageData.sidebar_active = true;
					$timeout(function() {
						vm.pageData.grid.resize();
					});
				}
			}
		};
	}
})();